<template>
    <div v-if="status === 'loaded'">
        <div class="admin-page text-center">
            <the-nav>
                <h1>Letrados</h1>

                <div class="buttons-container">
                    <button class="btn btn-danger icon-wrapper"
                            @click="emptyFilters">
                        <i class="uq-icon bi-filter"></i>&nbsp;Limpiar filtros
                    </button>

                    <button class="btn btn-download icon-wrapper"
                            v-if="can('export.lawyers')"
                            @click="downloadLawyers(filters)">
                        <i class="uq-icon bi-download"></i>
                    </button>

                    <button class="btn btn-secondary" type="button" @click="this.modalToShow = 'add-lawyer'"
                            title="Nuevo procurador" v-if="can('lawyer.store')">
                        <span>Añadir letrado</span>
                    </button>
                </div>
            </the-nav>

            <div class="row form-container" v-if="can('lawyer.index')">
                <div class="col-4 form-wrapper">
                    <div class="form-group search-form">
                        <label class="form-label">Nombre: </label>
                        <input type="text" class="form-control" aria-label="Nombre" v-model="filters.name"
                               @input="search"/>
                    </div>
                </div>

                <div class="col-4 form-wrapper">
                    <div class="form-group search-form">
                        <label class="form-label">Nº colegiado: </label>
                        <input type="text" class="form-control" aria-label="Nº colegiado"
                               v-model="filters.collegiate_number" @input="search"/>
                    </div>
                </div>

                <div class="col-4 form-wrapper">
                    <div class="form-group search-form">
                        <label class="form-label">Colegio: </label>
                        <input type="text" class="form-control" aria-label="Colegio" v-model="filters.college"
                               @input="search"/>
                    </div>
                </div>
            </div>

            <div class="admin-main">
                <v-table :meta="lawyers.meta" :pagination="lawyers.links.pagination" @pageChanged="pageChanged">
                    <template v-slot:header>
                        <th>Nombre</th>
                        <th>DNI</th>
                        <th>Número de colegiado</th>
                        <th>Colegio</th>
                        <th class="fit">Acciones</th>
                    </template>

                    <template v-slot:body>
                        <tr v-for="lawyer in lawyers.data">
                            <td>{{ lawyer.name }} {{ lawyer.surname}}</td>
                            <td>{{ lawyer.dni }}</td>
                            <td>{{ lawyer.collegiate_number }}</td>
                            <td>{{ lawyer.college }}</td>
                            <td class="fit">
                                <div class="actions-container">
                                    <button class="btn btn-show" @click="showLawyer(lawyer)"
                                            v-if="can('lawyer.show')">
                                        <i class="uq-icon bi-eye"></i>
                                    </button>

                                    <button class="btn btn-edit" @click="editLawyer(lawyer)"
                                            v-if="can('lawyer.update')">
                                        <i class="uq-icon bi-pencil"></i>
                                    </button>

<!--                                    <button class="btn btn-delete" @click="deleteLawyer(lawyer)"
                                                                                v-if="can('lawyer.destroy')">
                                                                            <i class="uq-icon bi-trash"></i>
                                                                        </button>-->
                                </div>
                            </td>
                        </tr>

                        <tr v-if="!lawyers.data">
                            <td colspan="222222">No hay letrados</td>
                        </tr>
                    </template>
                </v-table>

                <div v-if="status === 'loading'">
                    <div class="loader-container">
                        <div class="loader"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="status === 'errorPermissions' && user.roleName !== 'Admin'">
        No tienes permisos
    </div>

    <lawyers-list-show-modal v-if="modalToShow === 'show-lawyer'" :lawyer="selectedLawyer"
                             @closed="modalToShow = null"></lawyers-list-show-modal>
    <lawyers-list-edit-modal v-if="modalToShow === 'edit-lawyer'" :lawyer="selectedLawyer"
                             @closed="modalToShow = null; loadLawyers()"></lawyers-list-edit-modal>
    <lawyers-list-delete-modal v-if="modalToShow === 'delete-lawyer'" :lawyer="selectedLawyer"
                               @closed="modalToShow = null; loadLawyers()"></lawyers-list-delete-modal>
    <lawyers-list-add-modal v-if="modalToShow === 'add-lawyer'"
                            @closed="modalToShow = null; loadLawyers()"></lawyers-list-add-modal>
</template>

<script>
import LawyersListAddModal from "./parts/LawyersListAddModal";
import LawyersListShowModal from "./parts/LawyersListShowModal";
import LawyersListEditModal from "./parts/LawyersListEditModal";
import LawyersListDeleteModal from "./parts/LawyersListDeleteModal";
import {can} from "../../helpers/Permissions";
import TheNav from "../layouts/TheNav";
import {downloadLawyersXLSX} from "../../helpers/Exports";
import router from "../../router";
import {getLawyersPaginated} from "../../helpers/requests/RequestsLawyers";
import {withTimeout} from "../../helpers/requests/RequestsCore";
import VPagination from "../general/VPagination";
import {filtersToQueryParameters, setQueryParameters} from "../../helpers/Url";
import VTable from "../general/VTable";

export default {
    name: "LawyersList",
    components: {
        VPagination,
        TheNav,
        LawyersListDeleteModal,
        LawyersListEditModal,
        LawyersListShowModal,
        LawyersListAddModal,
        VTable
    },
    setup() {
        return {
            can,
            downloadLawyersXLSX
        }
    },
    data() {
        return {
            status: 'loading',
            lawyers: [],
            lawyer: null,
            selectedLawyer: null,
            modalToShow: null,
            user_permissions: window.permissions,

            do_search: true,

            filters: {
                name: '',
                collegiate_number: '',
                college: '',
                page: 1,
            },
            timers: {
                search: '',
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user.userLogged;
        }
    },
    async mounted() {
        // Read query params to form filters
        await this.setQueryParametersAsFilters();
        await this.doSearch();
        this.status = 'loaded';
    },
    watch: {
        $route(to, from) {
            // Apply only if we are operating over the same view
            if (to.name === from.name) {
                // TODO: Watch this and just only change url query parameters when methods fire something? This will do the rest
                this.setQueryParametersAsFilters();

                // We force it to not search because of a two-requests problem
                if (this.do_search === true) {
                    this.doSearch();
                }

                this.do_search = true;
            }
        }
    },
    methods: {
        downloadLawyers(filters) {
            this.$store.dispatch('app/setToastMessage', 'Procesando la descarga...');
            downloadLawyersXLSX(filters);
        },
        async doSearch() {
            this.do_search = false;
            await this.setFiltersAsQueryParameters();
            await this.loadLawyers();
        },
        emptyFilters() {
            this.filters = {
                name: '',
                collegiate_number: '',
                college: '',
                page: 1,
            };

            this.doSearch();
        },
        /**
         * Reads all the url query parameters and sets them as local filters.
         */
        setQueryParametersAsFilters() {
            let query_parameters = router.currentRoute.value.query;

            if (query_parameters.name) {
                this.filters.name = query_parameters.name;
            } else {
                this.filters.name = '';
            }
            if (query_parameters.collegiate_number) {
                this.filters.collegiate_number = query_parameters.collegiate_number;
            } else {
                this.filters.collegiate_number = '';
            }
            if (query_parameters.college) {
                this.filters.college = query_parameters.college;
            } else {
                this.filters.college = '';
            }
            if (query_parameters.page) {
                this.filters.page = query_parameters.page;
            } else {
                this.filters.page = 1;
            }
        },
        /**
         * Sets the local filters as url query parameters.
         */
        setFiltersAsQueryParameters() {
            setQueryParameters('lawyer.index', this.filters);
        },
        async loadLawyers() {
            let query = filtersToQueryParameters(this.filters);

            this.lawyers = await getLawyersPaginated(query);
        },
        search() {
            this.timers.search = withTimeout(async () => {
                this.filters.page = 1;
                await this.doSearch();
            }, this.timers.search, 250);
        },
        async pageChanged(page) {
            this.filters.page = page;
            await this.doSearch();
        },
        showLawyer(lawyer) {
            this.modalToShow = 'show-lawyer';
            this.selectedLawyer = lawyer;
        },
        editLawyer(lawyer) {
            this.modalToShow = 'edit-lawyer';
            this.selectedLawyer = lawyer;
        },
        deleteLawyer(lawyer) {
            /*            if (vConfirm('Borrar usuario', '¿Estás seguro de que deseas borrar el usuario?', 'Sí', 'No')) {
                            // LLamas al método de borrado
                        }*/
            this.modalToShow = 'delete-lawyer';
            this.selectedLawyer = lawyer;
        },
        addLawyer() {
            this.modalToShow = 'add-lawyer';
        }
    }
}
</script>
